
let portNumberLocal = localStorage.getItem('BondTimeportNoData');

let baseUrlToGiveBack = null

if (portNumberLocal) {

    // console.log("portNumber ", portNumberLocal)

    let portNumber = JSON.parse(portNumberLocal)

    // console.log("portNumber ", portNumber)

    // baseUrlToGiveBack = portNumber[0].IMG_API_PATH
// changed image post api 03/06/2025 
    baseUrlToGiveBack = portNumber[0].IMG_POST_PATH


    console.log("baseUrlToGiveBack--> ", baseUrlToGiveBack)


}



export let base_url_image_post_api = baseUrlToGiveBack